<template>
  <div class="audit">
    <div class="audit-container">
      <div class="ac-top">
        <div class="ac-title">审核图片</div>
        <!-- <i @click="onClose" class="el-icon-close close"></i> -->
      </div>
      <div ref="imgContainer" class="ac-content custom1-scrollbar">
        <div v-for="(item,index) in currentPhotoList" :key="`${examIdShow}${index}`" class="acc-item" :style="styleItem">
          <ImgAuth :authData="item"></ImgAuth>
        </div>
        <div class="ac-foot">
          <div class="ac-info">
            <div v-if="examInfo.admissionTicketNo">准考证：{{examInfo.admissionTicketNo}}</div>
          </div>
          <div ref="live" class="ac-live"></div>
          <div class="submit">
            <div class="si-tip">
              <div class="is-timer">
                <template v-if="watchTime > paintingPhotoDuration">
                  已超时 {{GetDateTime(watchTime)}}
                </template>
                <template v-else>
                  审核计时 {{GetDateTime(watchTime)}}
                </template>
              </div>
              <div class="is-imgscheck">
                <div class="font-24">通过照片数量：{{curretCheck.isCheck}}</div>
                <div class="font-24">打回照片数量：{{curretCheck.noCheck}}</div>
              </div>
            </div>
            <template v-if="showLoading">
              <el-button v-if="[1,2].includes(reviewStatus)" class="aci-btn" @click="onOpenEnding">提前结束该考生</el-button>
              <el-button v-if="showBtn && [1].includes(reviewStatus)" class="aci-btn" type="success" @click="onAudit" icon="el-icon-check">通过审核</el-button>
              <el-button v-if="[2].includes(reviewStatus)" class="aci-btn" type="success" @click="onAudit" icon="el-icon-check">通过审核</el-button>
              <template v-if="(!showBtn || showBtn1) && [1].includes(reviewStatus)">
                <el-button class="aci-btn ac-btn-red" @click="onReturnAudit" icon="el-icon-close">打回重新上传</el-button>
                <!-- <div class="error-tip">* 仅打回”X”图片</div> -->
                <div class="error-tip">* 仅打回
                  <div class="iic-normal iic-item iic-selectno">
                    <i class="el-icon-close"></i>
                  </div>图片
                </div>
              </template>
              <el-button v-if="[3].includes(reviewStatus)" class="aci-btn ac-btn-green">已结束审核</el-button>
            </template>
          </div>
          <div class="confirm-btn">
            <el-button @click="onClose">关闭审核</el-button>
            <el-button @click="onNextStudent" class="ac-btn-blue">下一个考生</el-button>
          </div>
        </div>
      </div>
      <el-dialog title="结束审核原因" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
        <el-form :model="form" ref="ruleForm">
          <el-form-item label="结束审核原因" prop="markedContent" :rules="[
              { required: true, message: '请填写结束审核原因', trigger: 'blur' }
            ]">
            <el-input type="textarea" :rows="2" maxlength="100" show-word-limit v-model="form.markedContent"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import ImgAuth from './img-auth.vue'
import ApiLogin from '@/apis/api-login.js'
export default {
  components: { ImgAuth },
  data() {
    return {
      watchTime: 0, // 监控总时间
      wTimer: null,
      examInfo: {},
      showLoading: true,
      dialogFormVisible: false,
      form: {
        markType: 4,
        markedContent: '',
      },
      markTypeArr: [],
      styleItem: {width: '33.33%', height: '220px'}
    }
  },
  computed: {
    showBtn() {
      return this.$store.state.authimgStore.showBtn
    },
    showBtn1() {
      return this.$store.state.authimgStore.showBtn1
    },
    curretCheck() {
      return this.$store.state.authimgStore.curretCheck
    },
    paintingPhotoDuration() {
      const curSubject = this.$store.state.authimgStore.curSubject
      return curSubject && curSubject.paintingPhotoDuration
        ? curSubject.paintingPhotoDuration
        : 0
    },
    paperReview() {
      return this.$store.state.authimgStore.paperReview
    },
    currentExam() {
      return this.$store.state.authimgStore.currentExam
    },
    examIdShow() {
      const currentExam = this.$store.state.authimgStore.currentExam
      return currentExam ? currentExam.examId : ''
    },
    //  reviewStatus: 审核状态 1待审核 2-复审(重新提交) 3-审核完成
    reviewStatus() {
      const currentExam = this.$store.state.authimgStore.currentExam
      return currentExam ? currentExam.reviewStatus : ''
    },
    currentPhotoList() {
      return this.$store.state.authimgStore.currentPhotoList
    },
  },
  watch: {
    reviewStatus() {
      this.showLoading = true
    },
    examIdShow() {
      this.showLoading = true
    },
    currentPhotoList() {
      this.styleItem = this.setLayoutImg()
    }
  },
  mounted() {
    const _this = this
    // this.markTypeArr = this.$utils.$localStorage.get("markTypeArr") || [];
    _this.setVideoView()
    window.onresize = () => {
      _this.setVideoView()
    }
    this.$once('hook:beforeDestroy', () => {
      const { examId } = this.currentExam
      if (examId) {
        window.core.closeCheckingExaminee(examId || '')
      }
    })
    this.setWatchTime()
    this.styleItem = this.setLayoutImg()
  },
  methods: {
    setLayoutImg() {
      const layoutDom = this.$refs.imgContainer.getBoundingClientRect()
      // const layoutHeight = this.$utils.$localStorage.get("layoutHeight");
      const imgLen = this.currentPhotoList ? this.currentPhotoList.length : 0
      let result = {width: '33.33%', height: '220px'}
      const layoutEnums = {
        1: { width: '100%', line: 1, height: '100%' },
        2: { width: '50%', line: 1, height: '100%' },
        3: { width: '50%', line: 2, height: '220px' },
        4: { width: '50%', line: 2, height: '220px' },
        5: { width: '33.33%', line: 2, height: '220px' },
        6: { width: '33.33%', line: 2, height: '220px' },
        7: { width: '33.33%', line: 3, height: '220px' },
        8: { width: '33.33%', line: 3, height: '220px' },
        9: { width: '33.33%', line: 3, height: '220px' },
        10: { width: '33.33%', line: 4, height: '220px' },
        11: { width: '33.33%', line: 4, height: '220px' },
        12: { width: '33.33%', line: 4, height: '220px' },
      }
      const objKeys = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
      for (let index = 0; index < objKeys.length; index++) {
        const key = objKeys[index];
        if (key == imgLen) {
          const line = layoutEnums[key].line
          layoutEnums[key].height = `${layoutDom.height / line}px`
          result = {width: layoutEnums[key].width, height: `${(layoutDom.height - 40 - 10 * line) / line}px`}
          break
        }
      }
      // console.log(result, 'styleItem')
      return result
    },
    setVideoView() {
      const _this = this
      const { examId } = this.currentExam || {}
      if (examId) {
        const { x, y, width, height } = this.$refs.live.getBoundingClientRect()
        // console.log(x, y, width, height, examId, '1111111')
        window.core.showCheckingExaminee(
          examId,
          Math.ceil(x),
          Math.ceil(y),
          width,
          height
        )
        this.onHandleExamineeStatus()
      } else {
        setTimeout(() => {
          _this.setVideoView()
        }, 1000)
      }
    },
    onClose() {
      window.onresize = null
      const { examId } = this.currentExam
      this.$store.dispatch('setCurrentView', 1)
      this.$store.dispatch('setCurrentExam', null)
      this.$store.dispatch('setCurrentPhotoList', [])
      window.core.closeCheckingExaminee(examId || '')
    },
    async onAudit() {
      const { examId, examSubjectId } = this.currentExam
      const { roomId } = this.paperReview
      const userInfo = this.$utils.$localStorage.get('userInfo')
      const param = {
        roomId,
        roundId: userInfo.currentRoundId || userInfo.roundId,
        reviewList: []
      }
      const item = {
        examId,
        examSubjectId,
        isFinish: this.showBtn ? 1 : 0,
        photoList: []
      }
      this.currentPhotoList.forEach((v) => {
        if (v.status > -1) {
          item.photoList.push({
            index: v.index,
            isApproved: v.checked ? 1 : 0,
            prevFileUrl: v.prevFileUrl || ''
          })
        }
      })
      param.reviewList = [item]
      try {
        await ApiLogin.POSTpaperReview(param)
        this.showLoading = false
      } catch (error) {
        this.showLoading = false
      }
    },
    async onReturnAudit() {
      const { examId, examSubjectId } = this.currentExam
      const { roomId } = this.paperReview
      const userInfo = this.$utils.$localStorage.get('userInfo')
      const param = {
        roomId,
        roundId: userInfo.currentRoundId || userInfo.roundId,
        reviewList: []
      }
      const item = {
        examId,
        examSubjectId,
        isFinish: 0,
        photoList: [],
      }
      this.currentPhotoList.forEach((v) => {
        if (v.status > -1) {
          item.photoList.push({
            index: v.index,
            isApproved: v.checked ? 1 : 0,
            prevFileUrl: v.prevFileUrl || ''
          })
        }
      })
      param.reviewList = [item]
      try {
        await ApiLogin.POSTpaperReview(param)
        this.showLoading = false
      } catch (error) {
        this.showLoading = false
      }
    },
    async onEnding() {
      const { examId, examSubjectId } = this.currentExam
      const { roomId } = this.paperReview
      const userInfo = this.$utils.$localStorage.get('userInfo')
      const param = {
        roomId,
        roundId: userInfo.currentRoundId || userInfo.roundId,
        reviewList: [{
          examId,
          examSubjectId,
          isFinish: 1,
          photoList: [],
        }]
      }
      try {
        await ApiLogin.POSTpaperReview(param)
        this.showLoading = false
      } catch (error) {
        this.showLoading = false
      }
    },
    onOpenEnding() {
      this.dialogFormVisible = true
      this.form.markedContent = ''
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const { examId, examSubjectId } = this.currentExam || {}
          const user = this.$utils.$localStorage.get('userInfo')
          await this.$HTTP.ApiLogin.POSTmarkStudent({
            markType: this.form.markType,
            teacherName: user.teacherName,
            teacherCreNumber: user.teacherCreNumber,
            roundId: user.roundId,
            examType: user.examType,
            markContent: this.form.markedContent,
            streamId: '',
            examSubjectId,
            examId,
            imgUrl: ''
          });
          await this.onEnding()
          this.dialogFormVisible = false
        } else {
          return false
        }
      })
    },
    async onHandleExamineeStatus() {
      const { examId } = this.currentExam || {}
      if (examId) {
        const res = await ApiLogin.POSTgetExamDetail({ examId })
        const { examSubjectName, admissionTicketNo } = res
        // 姓名: examineeName,   准考证号: examNo
        this.examInfo = {
          examSubjectName,
          admissionTicketNo,
        }
      }
    },
    setWatchTime() {
      this.onClearTimer()
      const { handleDuration } = this.currentExam || {}
      this.watchTime = handleDuration > 0 ? handleDuration : 0
      const timer = setInterval(() => {
        this.watchTime += 1
      }, 1000)
      this.wTimer = timer
      this.$once('hook:beforeDestroy', () => {
        this.onClearTimer()
      })
    },
    onClearTimer() {
      if (this.wTimer) {
        clearInterval(this.wTimer)
        this.wTimer = null
      }
    },
    GetDateTime(time) {
      var str = '00 : 00'
      var m =
        parseInt(time / 60) < 10
          ? `0${parseInt(time / 60)}`
          : parseInt(time / 60)
      var s = time % 60 < 10 ? `0${time % 60}` : time % 60
      str = `${m} ：${s}`
      return str
    },
    onNextStudent() {
      const { examId, examSubjectId } = this.currentExam || {}
      const { reviewList } = this.paperReview || {}
      if (reviewList && reviewList.length) {
        // reviewStatus 审核状态 1待审核 2-复审(重新提交) 3-审核完成
        const tar = reviewList.filter(
          (v) => ((v.examId !== examId) || (v.examSubjectId !== examSubjectId && v.examId == examId)) && v.reviewStatus == 1
        )
        if (tar && tar.length) {
          this.$store.dispatch('setCurrentExam', tar[0])
          this.$store.dispatch('setCurrentPhotoList', tar[0].list)
          this.setVideoView()
          this.setWatchTime()
          this.onHandleExamineeStatus()
        } else {
          this.$message.error('暂无待审核考生！')
        }
      } else {
        this.$message.error('暂无待审核考生！')
      }
    },
  },
  destroyed() {
    console.log('audit-view-----------destroyed')
  }
}
</script>
<style lang="scss" scoped>
.audit {
  width: 100%;
  height: 100%;
  background: rgba(4, 4, 15, 0.3);
  // padding: 20px 16px;
  color: #252526;
  &-container {
    background: #FFFFFF;
    // border-radius: 8px;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .ac-top {
      padding: 0 15px;
      width: 100%;
      height: 62px;
      border-bottom: 1px solid #E9E9E9;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .close {
        font-size: 20px;
        font-weight: bold;
        cursor: pointer;
      }
      .ac-title {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
      }
    }
    .ac-content {
      position: relative;
      overflow-y: auto;
      overflow-x: none;
      flex: 1;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      padding: 20px 25px;
      padding-right: 325px;
      .acc-item {
        width: 33.33%;
        height: 220px;
        // height: calc(100vh - 112px);
        padding: 5px;
      }
    }
    .ac-foot {
      position: absolute;
      right: 0;
      top: 0;
      width: 300px;
      border-top: 1px solid #E9E9E9;
      background: #F2F8FF;
      height: 100%;
      // padding: 0 68px;
      display: flex;
      align-items: center;
      flex-direction: column;
      .ac-live {
        width: 100%;
        height: 168px;
        border: 1px solid #E9E9E9;
      }
      .ac-info {
        width: 300px;
        height: 32px;
        background: rgba(0, 0, 0, 0.45);
        text-align: center;
        line-height: 32px;
        color: #fff;
        font-size: 14px;
      }
      .submit {
        width: 100%;
        padding: 20px;
      }
      .is-btn {
        margin: 15px 0;
      }
      .si-tip {
        width: 100%;
        border: 1px solid #707070;
        border-radius: 4px;
      }
      .is-timer {
        width: 100%;
        height: 32px;
        background: rgba(0, 0, 0, 0.45);
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
      }
      .is-imgscheck {
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      .error-tip {
        display: flex;
        justify-content: center;
        align-items: center;
        // text-align: center;
        width: 100%;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        // line-height: 22px;
        color: rgba(0, 0, 0, 0.45);
      }
      .iic-item {
        display: inline-block;
        width: 20px;
        height: 20px;
        border: 1px solid #FFF;
        box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.16);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFF;
        margin: 0 3px;
      }
      .iic-normal {
        background: rgba(0, 0, 0, 0.4);
      }
      .iic-selectno {
        background: #FF6262;
      }
      .confirm-btn {
        position: absolute;
        bottom: 20px;
        right: 0;
        left: 0;
        width: 100%;
        display: flex;
        justify-content: center;
      }
    }
  }
}
.aci-btn::v-deep.el-button {
  width: 260px !important;
  margin: 10px 0;
}
.ac-btn-blue::v-deep.el-button {
  color: #409EFF !important;
  border-color: #409EFF !important;
}
.ac-btn-green::v-deep.el-button {
  color: #2CD4AD !important;
  border-color: #2CD4AD !important;
}
.ac-btn-red::v-deep.el-button {
  color: #F56C6C !important;
  border-color: #F56C6C !important;
}
</style>
